var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.934 7.26367V9.3308C13.934 9.60259 13.7985 9.85141 13.584 9.97295L10.7825 11.5597C10.4721 11.7358 10.1879 11.9626 9.93793 12.2334C9.693 12.4985 9.30703 12.4985 9.0621 12.2334C8.81211 11.9626 8.5279 11.7358 8.21752 11.5597L5.41606 9.97295C5.20153 9.85141 5.06598 9.60259 5.06598 9.3308V7.26367L8.97807 8.53027C9.31248 8.63865 9.67539 8.64262 10.022 8.53027L13.934 7.26367Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4678 6.44354V10.7663C16.4678 11.1625 16.184 11.4841 15.8344 11.4841C15.4847 11.4841 15.2009 11.1625 15.2009 10.7663V6.85362L16.4678 6.44354Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.326 7.14994L0.457925 4.27893C-0.152114 4.08145 -0.153169 3.09651 0.457925 2.89865L9.326 0.0276335C9.43972 -0.00921116 9.56028 -0.00921116 9.674 0.0276335L18.5421 2.89865C19.1521 3.09612 19.1532 4.08107 18.5421 4.27893L9.674 7.14994C9.56075 7.1866 9.44018 7.18688 9.326 7.14994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/Academic.3dbfe597.svg";
export { ForwardRef as ReactComponent };